
export const NavigationMenu = ({ className, white }) => {
  return (
    <div
      className={'navigation-menu d-flex align-items-center justify-content-between ' + className}
    >
      <a href={'/genesis-studio'} className="navmenu-link navmenu-link-yellow">
        STUDIO
      </a>
      <a href={'/listen'} className="navmenu-link navmenu-link-pink">
        LISTEN
      </a>
      <a
        href="https://opensea.io/collection/arpeggi-genesis-studio-pass"
        className="navmenu-link navmenu-link-blue"
        target="_blank"
      >
        OPENSEA
      </a>
      <div className="d-flex align-items-center justify-content-center px-1">
        <a
          className="me-4 me-md-5"
          target="_blank"
          href="https://medium.com/@arpeggilabs/arpeggi-studio-4bf465348d51"
        >
          {/* <a className="me-5" target="_blank" href="https://opensea.io/collection/arpeggi-genesis-studio-pass"> */}
          <img
            className="topnav-img"
            src={'/static/icons/Medium' + (white ? '_white' : '') + '.svg'}
          />
        </a>
        <a className="me-4 me-md-5" target="_blank" href="https://discord.com/invite/yBxhcBwNyg">
          <img
            className="topnav-img"
            src={'/static/icons/Discord' + (white ? '_white' : '') + '.svg'}
          />
        </a>
        <a target="_blank" href="https://twitter.com/arpeggi_labs">
          <img
            className="topnav-img"
            src={'/static/icons/Twitter' + (white ? '_white' : '') + '.svg'}
          />
        </a>
      </div>
    </div>
  )
}

NavigationMenu.defaultProps = {
  white: false
}

export const TopnavLogo = () => {
  return (
    <div className="d-flex w-100 unselectable">
      <img
        src="/static/icons/arpeggi-logo.svg"
        className="pe-2"
        style={{ zIndex: '31', width: '35px', height: '35px' }}
      />
      <p className="mb-0 d-none d-md-block" style={{ fontWeight: '700', fontSize: '1.4rem' }}>
        ARPEGGI LABS
      </p>
    </div>
  )
}

export const Topnav = () => {
  return (
    <div className="row d-flex-column py-3 topnav" style={{ height: '96px' }}>
      <div className="col-12 col-md-6 d-flex align-items-center unselectable">
          <a href="/genesis">
            <TopnavLogo />
          </a>
      </div>
      <NavigationMenu className="col-12 col-lg-6" />
    </div>
  )
}
